export default [
	{
		path: '/beneficiaries',
		name: 'beneficiaries',
		component: () => import('@/views/Beneficiary/Beneficiaries.vue'),
		meta: { requiresAuth: true, permission: 'view_beneficiaries' }
	},
	{
		path: '/beneficiaries/create',
		name: 'beneficiaries.create',
		component: () => import('@/views/Beneficiary/CreateBeneficiary.vue'),
		meta: { requiresAuth: true, permission: 'create_beneficiary' }
	}
]
